"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useToSubtitle = void 0;
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _ListItemText = _interopRequireDefault(require("../../ListItemText"));
var _Divider = _interopRequireDefault(require("../../Divider"));
var _Help = require("../../Help");
var _constants = require("../constants");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var useToSubtitle = exports.useToSubtitle = function useToSubtitle() {
  return (0, _react.useCallback)(function (option) {
    var optionId = "option-latest-subtitle";
    return {
      type: _constants.TYPE_SUBTITLE,
      key: optionId,
      data: option,
      isButton: false,
      render: function render() {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(React.Fragment, {
          children: [option.withDivider ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Divider["default"], {
            sx: {
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0
            }
          }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemText["default"], {
            primaryTypographyProps: {
              noWrap: true,
              disableTooltip: true,
              variant: 'caption'
            },
            primary: option.tooltip ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(React.Fragment, {
              children: [option.name, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Help.Help, {
                sx: {
                  marginLeft: 1
                },
                children: option.tooltip
              })]
            }) : option.name
          })]
        });
      }
    };
  }, []);
};